import React from 'react';
import Text from '@raydiant/raydial/components/Text';

interface PresentationCardProps {
  img: React.ReactNode;
  label: string;
  onClick: () => void;
}

function PresentationCard({ img, label, onClick }: PresentationCardProps) {
  return (
    <div
      className="flex flex-col items-center justify-center cursor-pointer"
      onClick={() => onClick()}
    >
      <div
        className="w-[217px] h-[142px] rounded-t-[20px] justify-between flex bg-center bg-no-repeat bg-cover mb-4"
        style={{
          backgroundImage: `url(${img})`,
        }}
      />
      <Text variant="caption" className="text-gray-600">
        {label}
      </Text>
    </div>
  );
}

export default PresentationCard;
